import React, {Fragment, useState} from 'react';
import {useForm} from 'react-hook-form';
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    Tooltip,
    Grid,
    MuiIcons
} from "@leap4/frontend"
import style from "./style";
import {changePassword} from "../../../../actions/generic-crud-actions";
import {AlertTypes} from "../../../../utils/alert.utils";
import {generatePassword} from "../../../../utils/password.utils";

const { Autorenew: AutorenewIcon, Visibility: VisibilityIcon, VisibilityOff: VisibilityOffIcon, ContentCopy: ContentCopyIcon } = MuiIcons;

interface IProps {
    id: string;
    schemaName: string;
}


interface IFormData {
    password: string;
    password2: string;
}

const DialogChangePassword = ({
                                  id,
                                  schemaName
                              }: IProps): JSX.Element => {


    const classes = style();
    const {register, handleSubmit, setValue, watch} = useForm();
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [alert, setAlert] = useState<{showAlert: boolean, msg: string, alertStyle: React.CSSProperties}>({
        showAlert: false,
        msg: '',
        alertStyle: {},
    });

    const passwordValue = watch('password');
    const password2Value = watch('password2');

    const handleGeneratePassword = () => {
        const newPassword = generatePassword(16);
        setValue('password', newPassword);
        setValue('password2', newPassword);
        setShowPassword(true); // Show the generated password
    };

    const handleCopyPassword = () => {
        if (passwordValue) {
            navigator.clipboard.writeText(passwordValue);
            LunchAlert("Password copied!", classes[AlertTypes.SUCCESS]);
        }
    };

    const LunchAlert = (msg: string, alertStyle: React.CSSProperties) => {
        //show the alert
        setAlert({showAlert: true, msg, alertStyle});
        setTimeout(() => {
            //hide  the alert tag
            setAlert({showAlert: false, msg: '', alertStyle: {}});
        }, 2000);
    };

    const onSubmit = async (e: any) => {
        e.preventDefault();
        e.stopPropagation()

        await handleSubmit(async (obj: IFormData,) => {
            try {
                const {password, password2} = obj;

                if (password !== password2) {
                    LunchAlert('Passwords arent match', classes[AlertTypes.FAILURE]);
                    return;
                }

                await changePassword(
                    id,
                    schemaName,
                    password,
                );

                LunchAlert("Password changed successfully...", classes[AlertTypes.SUCCESS]);
            } catch (err) {
                LunchAlert('Error happened, try again later.', classes[AlertTypes.FAILURE]);
            }
        })(e)
    };

    return (<Fragment>
            <Button fullWidth  variant="outlined" color="primary" onClick={() => {
                setIsDialogOpen(true)
            }}>
                Change Password
            </Button>
            <Dialog
                open={isDialogOpen}
                onClose={() => {
                    setIsDialogOpen(false)
                }}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" style={{fontFamily:"Quicksand"}}>
                    CHANGE PASSWORD
                </DialogTitle>
                <DialogContent>
                    {alert.showAlert && (
                        <div style={{...classes.text, ...alert.alertStyle}}>
                            {alert.msg}
                        </div>
                    )}
                    <form
                        style={classes.form}
                        onSubmit={
                            onSubmit
                        }
                    >
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="password"
                                    label="New Password"
                                    type={showPassword ? "text" : "password"}
                                    fullWidth
                                    inputRef={register}
                                    required
                                    InputLabelProps={{ shrink: !!passwordValue }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title={showPassword ? "Hide password" : "Show password"}>
                                                    <IconButton
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Copy password">
                                                    <IconButton
                                                        onClick={handleCopyPassword}
                                                        edge="end"
                                                        size="small"
                                                        disabled={!passwordValue}
                                                    >
                                                        <ContentCopyIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    name="password2"
                                    label="Repeat new password"
                                    type={showPassword ? "text" : "password"}
                                    fullWidth
                                    inputRef={register}
                                    InputLabelProps={{ shrink: !!password2Value }}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 1 }}>
                                <Tooltip title="Generate a secure random password">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleGeneratePassword}
                                        startIcon={<AutorenewIcon />}
                                        fullWidth
                                    >
                                        Generate Password
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Grid>

                        <Button type="submit" variant="contained"
                                style={{marginTop: "20px", padding: "10px 50px 10px 50px"}} color="success">
                            Save
                        </Button>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setIsDialogOpen(!isDialogOpen)
                    }}

                            color="error">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default DialogChangePassword;